import { render } from "./Role.vue?vue&type=template&id=48d648c2&scoped=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"

import "./Role.vue?vue&type=style&index=0&id=48d648c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48d648c2"

export default script